import { useCallback, useEffect, useRef, useState } from "react";
import { ujmsV2DocPageBlob } from "../../services/ujmsApi";

/** Fetches rendered page PNGs (auth'd) and caches object URLs per document version. */
export function useDocPages(docId, version) {
  const cache = useRef(new Map());
  const [, bump] = useState(0);
  useEffect(() => {
    const c = cache.current;
    return () => { c.forEach((u) => u && URL.revokeObjectURL(u)); c.clear(); };
  }, [docId]);
  useEffect(() => { cache.current.forEach((u) => u && URL.revokeObjectURL(u)); cache.current.clear(); bump((n) => n + 1); }, [version]);
  const get = useCallback((page, scale) => {
    const key = `${page}@${scale}`;
    if (!cache.current.has(key)) {
      cache.current.set(key, null);
      ujmsV2DocPageBlob(docId, page, scale).then((r) => { cache.current.set(key, URL.createObjectURL(r.data)); bump((n) => n + 1); }).catch(() => cache.current.set(key, "error"));
    }
    return cache.current.get(key);
  }, [docId]);
  return get;
}
